const sportStyle = {
    container: `flex flex-col gap-4 w-full`,
}

const cardStyle = {
    card: `h-[125px] w-full rounded-[8px] gap-2 bg-cover bg-center flex flex-col items-center justify-center relative overflow-hidden border-[0.5px] cursor-pointer`,
    bottom_overlay: `absolute w-full h-full bg-no-repeat bg-cover bg-center z-[-1] opacity-40 left-0 top-0`,
    heading: `text-[20px] font-[600] leading-[20px] uppercase
              md:text-[23px] md:leading-[23px]
    `,
    subHeading: `text-primaryHeading font-[400] leading-[20px] text-[20px] uppercase
                 md:text-[23px] md:leading-[23px]
    `

}

export { sportStyle, cardStyle }